"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeCheckbox = void 0;
const react_1 = __importDefault(require("react"));
const attribute_checkbox_styles_1 = require("./attribute-checkbox.styles");
const AttributeCheckbox = (_a) => {
    var { onChange } = _a, props = __rest(_a, ["onChange"]);
    return (react_1.default.createElement(attribute_checkbox_styles_1.StyledCheckbox, Object.assign(Object.assign({}, props), { size: "small", onChange: onChange })));
};
exports.AttributeCheckbox = AttributeCheckbox;
exports.default = exports.AttributeCheckbox;
